import CalculatorByType from './CalculatorByType';

export default CalculatorByType;
